import { render, staticRenderFns } from "./fillGoals.vue?vue&type=template&id=126cdc21&scoped=true"
import script from "./fillGoals.vue?vue&type=script&lang=js"
export * from "./fillGoals.vue?vue&type=script&lang=js"
import style0 from "./fillGoals.vue?vue&type=style&index=0&id=126cdc21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126cdc21",
  null
  
)

export default component.exports